'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _dec2, _dec3, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _auth = require('redux/modules/auth');

var authActions = _interopRequireWildcard(_auth);

var _reactBootstrap = require('react-bootstrap');

var _reduxAsyncConnect = require('redux-async-connect');

var _reactI18next = require('react-i18next');

var _language = require('redux/modules/language');

var languageActions = _interopRequireWildcard(_language);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isLoaded = languageActions.isLoaded,
    loadTodayProgress = languageActions.loadTodayProgress;
var Admin = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  deferred: true,
  promise: function promise(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState,
        page = _ref.params.page;

    // console.log("asyncConnect");
    if (!isLoaded(getState())) {
      // console.log("not in here?");
      return dispatch(loadTodayProgress(3));
    }
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    todayProgress: state.language.todayProgress
  };
}, (0, _extends3.default)({}, authActions, languageActions)), _dec3 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = _dec3(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Admin, _Component);

  function Admin() {
    (0, _classCallCheck3.default)(this, Admin);
    return (0, _possibleConstructorReturn3.default)(this, (Admin.__proto__ || (0, _getPrototypeOf2.default)(Admin)).apply(this, arguments));
  }

  (0, _createClass3.default)(Admin, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // var LineChart = require("react-chartjs").Line;
      // var Highcharts = require('highcharts');
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          t = _props.t,
          user = _props.user,
          logout = _props.logout,
          todayProgress = _props.todayProgress;

      var langTracker = [];
      return user && _react2.default.createElement(
        'div',
        { className: 'container' },
        _react2.default.createElement(
          'h1',
          null,
          'Admin Page'
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            null,
            'Hi, ',
            user.email
          ),
          _react2.default.createElement(
            _reactBootstrap.Panel,
            null,
            'Streaks + total online days. ',
            _react2.default.createElement('br', null),
            'Your streaks: ',
            10,
            ' days'
          ),
          _react2.default.createElement(
            _reactBootstrap.Panel,
            null,
            'Show last pages you viewed. ... Last editted lessons.... and pinned lessons (or contents).'
          ),
          _react2.default.createElement(
            'p',
            null,
            'How to pickup the target language => to learn... '
          ),
          _react2.default.createElement(
            'p',
            null,
            'Also, show the best words, phrases => see more than 20 times...'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Use the phrases to create questions... how about the answers?'
          ),
          _react2.default.createElement(_reactBootstrap.Panel, null),
          _react2.default.createElement(
            'div',
            null,
            'Today'
          ),
          _react2.default.createElement(
            _reactBootstrap.Panel,
            { bsStyle: 'primary' },
            todayProgress && todayProgress.length === 0 && _react2.default.createElement(
              'div',
              null,
              'Hey, Keep It Up! Don\'t give up'
            ),
            todayProgress && todayProgress.map(function (progress) {
              langTracker.push(progress.lang);
              var _p; // = (parseInt(process.word_count) > 100) ? 100 : parseInt(process.word_count);
              if (progress.word_count > 100) {
                //replace 100 with another from server... 
                _p = 100;
              } else {
                _p = progress.word_count;
              }
              // console.log(_p);
              return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  progress.lang,
                  ' '
                ),
                _react2.default.createElement(_reactBootstrap.ProgressBar, { now: _p })
              );
            }),
            !langTracker.includes('es') && _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'span',
                null,
                'es'
              ),
              _react2.default.createElement(_reactBootstrap.ProgressBar, { now: 0 })
            ),
            !langTracker.includes('fr') && _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'span',
                null,
                'fr'
              ),
              _react2.default.createElement(_reactBootstrap.ProgressBar, { now: 0 })
            ),
            !langTracker.includes('de') && _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'span',
                null,
                'de'
              ),
              _react2.default.createElement(_reactBootstrap.ProgressBar, { now: 0 })
            ),
            _react2.default.createElement(
              'p',
              null,
              'If it\'s empty => get the old sentences to \'re-learn\'?'
            )
          ),
          _react2.default.createElement(
            'p',
            null,
            'Show what you have learned yesterday + the day before yesterday?'
          ),
          _react2.default.createElement(
            _reactBootstrap.Panel,
            null,
            'Words,sentences,languages....'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Show the entire progress'
          ),
          _react2.default.createElement(
            _reactBootstrap.Panel,
            null,
            'Create/Change an API to load the entire progress.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Analyze using Chart'
          ),
          _react2.default.createElement(
            _reactBootstrap.Panel,
            null,
            'Not easy here????'
          ),
          _react2.default.createElement(
            _reactBootstrap.Panel,
            null,
            'Some functions only work for admin account.',
            _react2.default.createElement('br', null),
            'Says: APIs for checking the contents is written in another language (or other languages)...'
          ),
          _react2.default.createElement(
            'div',
            null,
            'Show up the languages here'
          ),
          _react2.default.createElement(
            'div',
            null,
            'Pick up the language to analyze.'
          ),
          _react2.default.createElement(
            'div',
            null,
            'How to analyze the learning process.'
          ),
          _react2.default.createElement(
            'div',
            null,
            '---'
          ),
          _react2.default.createElement(
            'div',
            null,
            'When I\'m getting bored, then how to get up @@'
          ),
          _react2.default.createElement(
            'div',
            null,
            '----'
          ),
          _react2.default.createElement(
            'div',
            null,
            '***'
          ),
          _react2.default.createElement(
            'div',
            null,
            'Create a page that you can able to create a \'lesson\' with all contents'
          ),
          _react2.default.createElement(
            'div',
            null,
            'And yeah. learn from it... '
          ),
          _react2.default.createElement(
            'div',
            null,
            'Then, automatically generate a book. Possible?'
          ),
          _react2.default.createElement(
            'div',
            null,
            '***'
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              _reactBootstrap.Button,
              { href: '/knowledge/1', className: 'btn btn-default', onClick: function onClick(e) {
                  e.preventDefault();
                  _this2.props.history.push('/knowledge/1');
                } },
              _react2.default.createElement('i', { className: 'fa' }),
              ' ',
              'Your words'
            )
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              _reactBootstrap.Button,
              { href: '/account/contents', className: 'btn btn-default', onClick: function onClick(e) {
                  e.preventDefault();
                  _this2.props.history.push('/account/contents');
                } },
              _react2.default.createElement('i', { className: 'fa' }),
              ' ',
              'Your Lessons'
            )
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              _reactBootstrap.Button,
              { href: '/lessons', className: 'btn btn-default', onClick: function onClick(e) {
                  e.preventDefault();
                  _this2.props.history.push('/lessons');
                } },
              _react2.default.createElement('i', { className: 'fa' }),
              ' ',
              'All lessons?'
            )
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              _reactBootstrap.Button,
              { onClick: function onClick() {
                  return _this2.props.history.push('/content/create');
                } },
              t('content.create_content')
            )
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              _reactBootstrap.Button,
              { className: 'btn btn-default', onClick: function onClick() {
                  return _this2.props.history.push('/lesson/create');
                } },
              t('content.create_lesson')
            )
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              _reactBootstrap.Button,
              { href: '/knowledge/editor/1', className: 'btn btn-default', onClick: function onClick(e) {
                  e.preventDefault();
                  _this2.props.history.push('/knowledge/editor/1');
                } },
              _react2.default.createElement('i', { className: 'fa' }),
              ' ',
              'Edit Your Knowledge'
            )
          ),
          _react2.default.createElement(
            'p',
            null,
            'The same function will forward you to ',
            _react2.default.createElement(
              'code',
              null,
              '/'
            ),
            ' should you chose to log out. The choice is yours...'
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'button',
              { className: 'btn btn-danger', onClick: logout },
              _react2.default.createElement('i', { className: 'fa fa-sign-out' }),
              ' ',
              'Log Out'
            )
          )
        )
      );
    }
  }]);
  return Admin;
}(_react.Component), _class2.propTypes = {
  user: _react.PropTypes.object,
  logout: _react.PropTypes.func
}, _temp)) || _class) || _class) || _class);
exports.default = Admin;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Home/Admin.js
// module id = 1525
// module chunks = 0